module.exports = __webpack_public_path__ + "3ed59ba8277e9b08f227da3bfc257ffd.jpg";